import { useQuery } from '@apollo/client'
import { Checkbox, List, Typography } from 'antd'
import { keyBy } from 'lodash'
import React from 'react'

import { clientFeatureToggleGQL } from '@/components/feature-toggle/feature-toggle'
import { useFeatureToggle } from '@/components/feature-toggle/feature-toggle.hooks'
import { useGetFeatureTogglesQuery } from '@/generated/graphql'

import { useIsRootAdmin } from '../admin.hooks'

export const FeatureToggleComponent = () => {
  const { data } = useGetFeatureTogglesQuery()
  const { data: clientFeatureTogglesData } = useQuery(clientFeatureToggleGQL)

  const [onBoardingDBFeatureToggle, onBoardingClientFeatureToggle] = useFeatureToggle('onboarding')
  const [projectDBFeatureToggle, projectClientFeatureToggle] = useFeatureToggle('project')
  const [knowledgeLibraryDBFeatureToggle, knowledgeLibraryClientFeatureToggle] = useFeatureToggle('knowledgeLibrary')
  const [impactDBFeatureToggle, impactClientFeatureToggle] = useFeatureToggle('impact')
  const [bannerDBFeatureToggle, bannerClientFeatureToggle] = useFeatureToggle('banner')
  const [anniversaryCardDBFeatureToggle, anniversaryCardClientFeatureToggle] = useFeatureToggle('anniversaryCard')

  const isRootAdmin = useIsRootAdmin()
  const dbFeatureToggles = data ? keyBy(data.featureToggles, 'feature') : {}
  const clientFeatureToggles = clientFeatureTogglesData.clientFeatureTogglesCache

  return (
    <div style={{ padding: 32, flex: '1 0 49%' }}>
      <List
        header={<Typography.Title level={5}>FeatureToggle</Typography.Title>}
        dataSource={Object.keys(clientFeatureToggles)}
        renderItem={(item) => (
          <List.Item key={item}>
            <span>{item}</span>
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Checkbox
                checked={clientFeatureToggles[item]}
                onChange={() => {
                  switch (item) {
                    case 'onboarding':
                      onBoardingClientFeatureToggle()
                      break
                    case 'project':
                      projectClientFeatureToggle()
                      break
                    case 'knowledgeLibrary':
                      knowledgeLibraryClientFeatureToggle()
                      break
                    case 'impact':
                      impactClientFeatureToggle()
                      break
                    case 'banner':
                      bannerClientFeatureToggle()
                      break
                    case 'anniversaryCard':
                      anniversaryCardClientFeatureToggle()
                      break
                  }
                }}
              >{`client: ${clientFeatureToggles[item] ? 'on' : 'off'}`}</Checkbox>
              {isRootAdmin && dbFeatureToggles[item] && (
                <Checkbox
                  checked={dbFeatureToggles[item].value === 'true'}
                  onChange={() => {
                    switch (item) {
                      case 'onboarding':
                        onBoardingDBFeatureToggle()
                        break
                      case 'project':
                        projectDBFeatureToggle()
                        break
                      case 'knowledgeLibrary':
                        knowledgeLibraryDBFeatureToggle()
                        break
                      case 'impact':
                        impactDBFeatureToggle()
                        break
                      case 'banner':
                        bannerDBFeatureToggle()
                        break
                      case 'anniversaryCard':
                        anniversaryCardDBFeatureToggle()
                        break
                    }
                  }}
                >{`db: ${dbFeatureToggles[item].value === 'true' ? 'on' : 'off'}`}</Checkbox>
              )}
            </div>
          </List.Item>
        )}
      />
    </div>
  )
}
